export default __webpack_public_path__ + "static/media/info.b9bf4da2.svg";